import { createFileRoute } from '@tanstack/react-router';
import { PersonLiveNotificationsRoute } from './-route-wrappers';

/** The person profile's Live notifications tab at its own URL (FPS-4855). */
function PersonLiveNotificationsIndexRoute() {
  const { personId } = Route.useParams();

  return <PersonLiveNotificationsRoute personId={personId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/')({
  component: PersonLiveNotificationsIndexRoute,
});
